                                                                                                                         <template>
  <div>
    <h1 class="page-header">{{ $t('reportAttendanceDetail.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('reportAttendanceDetail.dateFrom')}}</label>
              <ts-date-picker-input v-model="model.date_from"></ts-date-picker-input>
              <div
                class="text-danger mt-2"
                v-if="errors.has('date_from')"
              >{{ errors.first('date_from')}}</div>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('reportAttendanceDetail.dateTo')}}</label>
              <ts-date-picker-input v-model="model.date_to"></ts-date-picker-input>
              <div
                class="text-danger mt-2"
                v-if="errors.has('date_to')"
              >{{ errors.first('date_to')}}</div>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('reportAttendanceDetail.organisationalStructure')}}</label>
              <treeselect
                :load-options="loadOptions"
                :options="orgOptions"
                :placeholder="$t('select')"
                v-model="model.org_chart_structure_id"
              />
              <div
                class="text-danger mt-2"
                v-if="errors.has('org_chart_structure_id')"
              >{{ errors.first('org_chart_structure_id')}}</div>
            </div>
            <div class="col-md-2 form-group">
              <label>{{ $t('reportAttendanceDetail.employeeName')}}</label>
              <treeselect
                :load-options="loadEmployees"
                :multiple="true"
                :limit="2"
                :options="employeeOptions"
                :placeholder="$t('all')"
                v-model="model.employee_id"
              />
            </div>
            <div class="col-md-2">
              <label></label>
              <ts-button
                @click="fetchData"
                class="mt-4"
                color="primary"
                :waiting="loading"
              >{{$t('button.view')}}</ts-button>
              <ts-button
                @click="exportExcel"
                class="mt-4 ml-2"
                color="success"
                outline
                :disabled="resources.length == 0"
                :waiting="exporting"
              >
                <i class="fas fa-file-excel"></i>
                {{$t('button.excel')}}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <div id="table-container">
          <ts-table
            :records="resources"
            :columnLengths="18"
            :rowGroup="{
                field: 'employee_name'
              }"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <th rowspan="2">{{ $t('reportAttendanceDetail.employeeCard') }}</th>
                  <th rowspan="2">{{ $t('reportAttendanceDetail.position') }}</th>
                  <th rowspan="2">{{ $t('reportAttendanceDetail.shift') }}</th>
                  <th rowspan="2">{{ $t('reportAttendanceDetail.datescan') }}</th>
                  <th colspan="2" class="text-center">{{ $t('reportAttendanceDetail.t1') }}</th>
                  <th rowspan="2" class="text-center">{{ $t('reportAttendanceDetail.total1') }}</th>
                  <th colspan="2" class="text-center">{{ $t('reportAttendanceDetail.t2') }}</th>
                  <th rowspan="2" class="text-center">{{ $t('reportAttendanceDetail.total2') }}</th>
                  <th colspan="2" class="text-center">{{ $t('reportAttendanceDetail.t3') }}</th>
                  <th rowspan="2" class="text-center">{{ $t('reportAttendanceDetail.total3') }}</th>
                  <th colspan="2" class="text-center">{{ $t('reportAttendanceDetail.t4') }}</th>
                  <th rowspan="2" class="text-center">{{ $t('reportAttendanceDetail.total4') }}</th>
                  <th rowspan="2" class="text-center">{{ $t('reportAttendanceDetail.attendance') }}</th>
                  <th rowspan="2">{{ $t('reportAttendanceDetail.presentStatus') }}</th>
                </tr>
                <tr>
                  <th>{{ $t('reportAttendanceDetail.checkin') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkout') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkin') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkout') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkin') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkout') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkin') }}</th>
                  <th>{{ $t('reportAttendanceDetail.checkout') }}</th>
                </tr>
                <TableProgressBar v-show="loading" :columnLength="18" />
              </thead>
            </template>
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">{{ record.card_id }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.position }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.shift_name }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.datescan }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t1 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t2 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.total_hour1 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t3 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t4 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.total_hour2 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t5 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t6 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.total_hour3 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t7 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.t8 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.total_hour4 }}</td>
              <td class="ts-whitespace-no-wrap text-center">{{ record.att_status }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.att_present_status }}</td>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'
import { Errors } from 'form-backend-validation'
import { trim } from 'lodash'
import { mapState, mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import moment from 'moment'

export default {
  name: 'reportAttendanceDetail',
  components: { TableProgressBar },
  data() {
    return {
      loading: false,
      exporting: false,
      model: {
        date_from: moment()
          .startOf('month')
          .format('DD-MM-YYYY'),
        date_to: moment()
          .endOf('month')
          .format('DD-MM-YYYY'),
        org_chart_structure_id: null,
        employee_id: []
      },
      employeeOptions: null,
      orgOptions: null,
      errors: new Errors()
    }
  },
  created() {},
  computed: {
    ...mapState('hr/reportAttendanceDetail', ['resources', 'pagination'])
  },
  methods: {
    ...mapActions('hr/reportAttendanceDetail', ['fetchOrgStructures', 'fetchEmployees']),
    async loadOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.orgOptions = null
        let response = await this.fetchOrgStructures()
        this.orgOptions = response.data.map(el => ({
          id: el.org_chart_structure_id,
          label: el.org_chart_structure
        }))
      }
    },
    async loadEmployees({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.employeeOptions = null
        if (this.model.org_chart_structure_id) {
          await this.fetchEmployees({
            org_chart_structure_id: this.model.org_chart_structure_id
          })
            .then(response => {
              this.employeeOptions = response.data.map(el => ({
                id: el.employee_id,
                label: el.employee_name_en + '|' + el.employee_name_kh
              }))
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
        }
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('hr/reportAttendanceDetail/fetch', Object.assign({}, this.model, attributes))
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('hr/reportAttendanceDetail/exportExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(response.headers['content-disposition'].indexOf('filename'))
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err)))
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    'model.org_chart_structure_id': function(value) {
      this.model.employee_id = []
      this.employeeOptions = null
      if (value) {
        this.fetchEmployees({ org_chart_structure_id: value })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>